<template>
  <div class="pagination-box" v-if="paginationLength > 1 && paginationPages">
    <PaginationButton v-on:set-active-page="setActivePage"
                      :pbutton-icon="'n-i-arrow-left-double'"
                      :pbutton-styles="{
                        backgroundColor: '#c0c5cc',
                        color: '#fff',
                      }"
                      :pbutton-active="false"
                      :pbutton-disabled="activePage === 1"
                      :pbutton-value="'start'">
    </PaginationButton>
    <PaginationButton v-on:set-active-page="setActivePage"
                      :pbutton-icon="'n-i-arrow-left-b'"
                      :pbutton-styles="{
                        backgroundColor: '#c0c5cc',
                        color: '#fff',
                      }"
                      :pbutton-active="false"
                      :pbutton-disabled="activePage === 1"
                      :pbutton-value="'previous'">
    </PaginationButton>
    <template v-if="paginationPages[0] > 1">
      <PaginationButton v-on:set-active-page="setActivePage"
                        :pbutton-styles="{
                        backgroundColor: 'transparent',
                        color: '#808b9c',
                      }"
                        :pbutton-active="activePage === 1"
                        :pbutton-value="'1'">
      </PaginationButton>
    </template>
    <template v-if="paginationPages[0] > 2">
      <PaginationButton :pbutton-styles="{
                        backgroundColor: 'transparent',
                        color: '#808b9c',
                      }"
                        :pbutton-disabled="true"
                        :pbutton-value="'...'" />
    </template>
    <PaginationButton v-for="(page, index) in paginationPages"
                      v-on:set-active-page="setActivePage"
                      :key="index"
                      :pbutton-value="page"
                      :pbutton-styles="{
                        backgroundColor: 'transparent',
                        color: '#808b9c',
                      }"
                      :pbutton-active="activePage === page" />
    <template v-if="paginationPages[paginationPages.length - 1] < paginationLength">
      <PaginationButton :pbutton-styles="{
                        backgroundColor: 'transparent',
                        color: '#808b9c',
                      }"
                        :pbutton-disabled="true"
                        :pbutton-value="'...'" />
    </template>
    <template v-if="paginationPages[paginationPages.length - 1] !== paginationLength">
      <PaginationButton v-on:set-active-page="setActivePage"
                        :pbutton-styles="{
                        backgroundColor: 'transparent',
                        color: '#808b9c',
                      }"
                        :pbutton-active="this.activePage
                      === this.paginationLength"
                        :pbutton-value="this.paginationLength" />
    </template>
    <PaginationButton v-on:set-active-page="setActivePage"
                      :pbutton-icon="'n-i-arrow-right-b'"
                      :pbutton-styles="{
                        backgroundColor: '#c0c5cc',
                        color: '#fff',
                      }"
                      :pbutton-active="false"
                      :pbutton-disabled="activePage === paginationLength"
                      :pbutton-value="'next'" />
    <PaginationButton v-on:set-active-page="setActivePage"
                      :pbutton-icon="'n-i-arrow-right-double'"
                      :pbutton-styles="{
                        backgroundColor: '#c0c5cc',
                        color: '#fff',
                      }"
                      :pbutton-active="false"
                      :pbutton-disabled="activePage === paginationLength"
                      :pbutton-value="'end'" />
    <div class="pagination-go-to">
      <InputBox v-on:input-section-box-action="setActivePage($event, 'object')"
                :rule-action="'enter'"
                :rule-placeholder="'admin_goToPage'"
                :rule-content="ruleContent"
                :rule-value="goToPageTouched ? activePage : ''"
                :rule-type="'number'" />
    </div>
  </div>
</template>

<script>
import { ceil, inRange, range } from 'lodash';
import PaginationButton from './PaginationButton';
import InputBox from '../layouts/InputBox';

export default {
  name: 'PaginationBox',
  components: { PaginationButton, InputBox },
  data() {
    return {
      paginationLength: null,
      paginationPages: null,
      startMaxNumber: 7,
      goToPageTouched: false,
      ruleContent: {
        validation: {
          minimum: 1,
          maximum: ceil(+this.pbPagination.total / this.pbPagination.count),
        },
      },
    };
  },
  props: [
    'pbPagination',
    'pbRowsPerPageActive',
    'activePage',
  ],
  methods: {
    /**
     * Returning array of see pages,  example (if we are on 5, we will return [3,4,5,6,7])
     */
    calcPaginationPages() {
      let paginationPages = [];
      this.startMaxNumber = this.paginationLength < 7
        ? this.paginationLength : 7;
      if (this.paginationLength === this.startMaxNumber + 1) {
        paginationPages = range(1, this.paginationLength + 1);
      } else {
        const sevenFromStart = inRange(this.activePage, 1, this.startMaxNumber);
        const sevenFromEnd = inRange(this.activePage,
          (this.paginationLength - this.startMaxNumber) + 2,
          this.paginationLength + 1);
        if (sevenFromStart) {
          paginationPages = range(1, this.startMaxNumber + 1);
        } else if (sevenFromEnd) {
          paginationPages = range((this.paginationLength - this.startMaxNumber) + 1,
            this.paginationLength + 1);
        } else {
          paginationPages = range(this.activePage - 2, this.activePage + 3);
        }
      }
      return paginationPages;
    },
    setActivePage(event, type = null) {
      this.$store.dispatch('setSelectedRow', 0);
      let value;
      if (type === 'object') {
        // eslint-disable-next-line prefer-destructuring
        value = +event.value;
        this.goToPageTouched = this.paginationLength >= value;
      } else {
        value = typeof event === 'string' ? event : +event;
        this.goToPageTouched = false;
      }
      let page;
      if (this.activePage !== value) {
        switch (value) {
          case 'start':
            page = 1;
            break;
          case 'previous':
            page = this.activePage - 1 > 1 ? this.activePage - 1 : 1;
            break;
          case 'next':
            page = this.activePage + 1 < this.paginationLength
              ? this.activePage + 1 : this.paginationLength;
            break;
          case 'end':
            page = this.paginationLength;
            break;
          default:
            page = +value;
            break;
        }
        if (this.paginationLength >= page && page > 0) {
          this.$emit('pagination-active-page', page);
          this.paginationPages = this.calcPaginationPages();
        }
      }
    },
    initPaginationBox() {
      this.paginationLength = ceil(this.pbPagination.total / this.pbPagination.count) > 0
        ? ceil(this.pbPagination.total / this.pbPagination.count) : 1;
      this.paginationPages = this.calcPaginationPages();
    },
  },
  mounted() {
    this.initPaginationBox();
  },
  watch: {
    pbPagination: {
      handler() {
        this.initPaginationBox();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
 .pagination-box {
   display: flex;
   height: 100%;
   .results-pagination {
     border-radius: 4px;
     display: inline-block;
     margin: 1.3rem 0;
     padding-left: 0;
     list-style-type: none;

     li {
       cursor: pointer;
       display: inline-block;
       float: left;
       height: 26px;
       width: 31px;
       button {
         font-size: .9rem;
         height: 100%;
         position: relative;
         width: 100%;
         i {
           font-size: .875rem;
         }
       }
     };
   }
   .pagination-go-to {
     height: 100%;
     margin-left: 40px;
     width: 96px;
     input {
       height: 100%;
       padding: 0 10px;
       width: 100%;
     }
   }
 }
</style>
